import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { createHomepageOfferClaimStore, type HomepageOfferClaimStore } from './homepageOfferClaimStore'

const HomepageOfferDedupContext = createContext<HomepageOfferClaimStore | undefined>(undefined)

interface Props {
  children: ReactNode
}

function HomepageOfferDedupProvider(props: Props) {
  const { children } = props
  const store = useMemo(() => createHomepageOfferClaimStore(), [])

  return (
    <HomepageOfferDedupContext.Provider value={store}>
      {children}
    </HomepageOfferDedupContext.Provider>
  )
}

export function useHomepageOfferClaimStore(): HomepageOfferClaimStore | undefined {
  return useContext(HomepageOfferDedupContext)
}

export default HomepageOfferDedupProvider
